import { KitButton, KitText } from '@omni/kit/components';
import { SizeClassV2, useSizeClass } from '@omni/kit/contexts/SizeClassContext';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import Colors from '@omni/kit/theming/Colors';
import Spacing from '@omni/kit/theming/Spacing';
import React, { ReactElement } from 'react';
import { Platform, View } from 'react-native';

interface AttendanceTypes {
  onPressAttendance: (mode: 'create') => void;
}

export default function EventAttendanceBarComponent({
  onPressAttendance,
}: AttendanceTypes): ReactElement {
  const { t } = useTranslation(['groups']);
  const { sizeClassV2 } = useSizeClass();
  const isLarge = sizeClassV2 >= SizeClassV2.L;

  return (
    <View
      style={{
        marginTop: Spacing.xxl,
        alignItems: 'center',
        marginBottom: Platform.OS === 'web' && isLarge ? Spacing.m : Spacing.xl,
      }}
    >
      <View
        style={{
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: Spacing.m,
        }}
      >
        <View style={{ alignItems: 'center', paddingHorizontal: Spacing.m }}>
          <KitText
            fontSize={20}
            bold
            color={Colors.N900}
            style={{ marginBottom: Spacing.xs, textAlign: 'center' }}
          >
            {t('noAttendanceBarTitle')}
          </KitText>
          <KitText fontSize={14} style={{ textAlign: 'center' }}>
            {t('groups:noAttendanceBarDescription')}
          </KitText>
        </View>

        <KitButton
          testID='attendance-bar-button'
          secondary
          iconSize={14}
          title={t('groups:takeAttendanceButton')}
          onPress={() => onPressAttendance('create')}
          style={{ alignSelf: 'center' }}
        />
      </View>
    </View>
  );
}
